import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import api from "@/lib/api";
import { fmtNum, formatDate, STATUS_COLORS } from "@/lib/constants";

export default function Orders() {
  const [orders, setOrders] = useState([]);
  useEffect(() => {
    api.get("/dealer/orders").then(({ data }) => setOrders(data));
  }, []);

  return (
    <div className="space-y-6" data-testid="dealer-orders-page">
      <div>
        <span className="label-tag">Geçmiş</span>
        <h1 className="font-serif text-4xl mt-2">Siparişlerim</h1>
      </div>

      <div className="bg-white border border-[#eae5dc] overflow-x-auto">
        <table className="w-full text-sm min-w-[600px]">
          <thead>
            <tr className="bg-[#f7f5f0] text-xs uppercase tracking-wider text-[#6b655c]">
              <th className="text-left py-3 px-4">Sipariş No</th>
              <th className="text-left py-3 px-4">Tarih</th>
              <th className="text-center py-3 px-4">Satır</th>
              <th className="text-right py-3 px-4">CM</th>
              <th className="text-right py-3 px-4">m²</th>
              <th className="text-center py-3 px-4">Durum</th>
            </tr>
          </thead>
          <tbody>
            {orders.length === 0 && <tr><td colSpan={6} className="py-12 text-center text-[#6b655c]">Henüz sipariş yok</td></tr>}
            {orders.map((o) => (
              <tr key={o.id} className="border-t border-[#f0ebe2]">
                <td className="py-3 px-4">
                  <Link to={`/bayi/siparislerim/${o.id}`} className="font-medium hover:text-[#c8a97e]" data-testid={`dealer-order-link-${o.order_no}`}>{o.order_no}</Link>
                </td>
                <td className="py-3 px-4 text-[#6b655c]">{formatDate(o.created_at)}</td>
                <td className="py-3 px-4 text-center">{(o.items || []).length}</td>
                <td className="py-3 px-4 text-right">{fmtNum((o.total_meters || 0) * 100)}</td>
                <td className="py-3 px-4 text-right font-medium">{fmtNum(o.total_sqm)}</td>
                <td className="py-3 px-4 text-center">
                  <span className={`text-xs px-2 py-1 ${STATUS_COLORS[o.status]}`}>{o.status}</span>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
}
